import type {
  ColumnViewControllerProps as ColumnViewControllerNewProps,
  TableColumnViewType as TableColumnViewNewType,
} from './ColumnViewController';

export interface OldTableColumnViewType<T> extends Omit<TableColumnViewNewType<T>, 'checked'> {
  /** @deprecated checked를 사용해주세요. */
  isOn?: boolean;
}

export interface OldColumnViewControllerProps<T> extends Omit<ColumnViewControllerNewProps<T>, 'columns' | 'onChange'> {
  columns: Array<OldTableColumnViewType<T>>;
  onChange: (columns: Array<OldTableColumnViewType<T>>) => void;
}

export function convertOldColumnViewControllerProps<T>(
  props: OldColumnViewControllerProps<T>,
): ColumnViewControllerNewProps<T> {
  const { columns, onChange, ...restProps } = props;

  return {
    ...restProps,
    columns: columns.map(({ isOn, ...column }) => ({ ...column, checked: isOn })),
    onChange: (nextColumns) => onChange(nextColumns.map(({ checked, ...column }) => ({ ...column, isOn: checked }))),
  };
}
